import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {Grid2 as Grid, TextField, Button, Typography} from "@mui/material";
import { makeStyles } from "@mui/styles";
import QuantitySelector from "../Common/QuantitySelector/QuantitySelector";

const useStyles = makeStyles(() => ({
	section: {
		marginBottom: 16,
		marginTop: 2.5,
	}
}));

export default function ScanEditWithSaveButton(props) {
	const classes = useStyles();
	const { onDataChange, onSaveItemClick, productId, productQty, enableAssignIbLocation } = props;
	const [qty, setQty] = useState(productQty);
	const [pid, setPid] = useState(productId);

	useEffect(() => {
		setQty(props.productQty);
		setPid(props.productId);
	}, [props.productQty, props.productId]);

	useEffect(() => {
		onDataChange({ qty, productId: pid });
	}, [onDataChange, qty, pid]);

	const onProductIdChange = (e) => {
		setPid(e.target.value);
	};

	const handleQuantityChange = (newQuantity) => {
		setQty(newQuantity);
	};

	return (
		<Grid container direction="column" spacing={1} className={classes.section}>
			<Grid size="grow">
				<Grid container justifyContent="flex-start">
					<Typography variant="body2">
						{enableAssignIbLocation ? "Scan location then item(s) to receive" : "Scan item(s) to receive"}
					</Typography>
				</Grid>
			</Grid>

			<Grid size="grow">
				<Grid container justifyContent="flex-start" alignItems="stretch">
					<Grid size={12}>
					<TextField
							fullWidth={true}
							margin="none"
							variant="outlined"
							label={enableAssignIbLocation ? "Location/PLU/Model/Sku" : "PLU/Model/Sku" }
							value={pid}
							onChange={onProductIdChange}
							autoComplete="off"
						/>
					</Grid>
				</Grid>
			</Grid>
			<Grid size="grow">
				<Grid direction="row" container justifyContent="space-between" alignItems="center">
					<Grid>
						<QuantitySelector 
							productQuantity={qty ? parseInt(qty.toString(), 10) : 0} 
							onQuantityChange={handleQuantityChange} />
					</Grid>
					<Grid>
						<Grid>
							<Button
								variant="contained"
								color="secondary"
								onClick={() => onSaveItemClick(productId, qty)}
								disabled={qty < 0 || !pid}
								style={{
									height: "100%",
									width: "100%",
									margin: "0px",
									padding: "8px 16px",
								}}
							>
								Add
							</Button>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
		</Grid>
	);
}

ScanEditWithSaveButton.propTypes = {
	onDataChange: PropTypes.func.isRequired,
	onSaveItemClick: PropTypes.func.isRequired,
	productId: PropTypes.string,
	productQty: PropTypes.number,
	isVisible: PropTypes.bool,
	enableAssignIbLocation: PropTypes.bool,
};
